module.exports = __webpack_public_path__ + "img/personal_icon_friend@2x.ff12623e.png";